import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useGetOneSupportCategory(data = {}) {
  const { enabled = false, queryParams = '', configs = {}, categoryId } = data;
  const { params = {} } = configs;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function getOneCategory() {
    return privateFetch
      .get(`/v1/admin/support/category/${categoryId}`, configs)
      .then((res) => res.data);
  }

  return useQuery(['podcast-category-getResource', params], getOneCategory, {
    enabled,
    keepPreviousData: true,
  });
}

export default useGetOneSupportCategory;
